export default {
  src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  autoBlockSrc:
    'https://cdn.cookielaw.org/consent/815b65cf-c2f1-4c7d-8832-3a42137b1c7a/OtAutoBlock.js',
  domainScript: '815b65cf-c2f1-4c7d-8832-3a42137b1c7a',
};
